<div class="avseg">
  <button type="button"
          *ngFor="let opt of options"
          [class.on]="opt.value === value"
          (click)="select(opt.value)">{{ opt.label }}</button>
</div>
